import React from 'react';

import { FormattedMessage } from '../../../util/reactIntl';
import { REVIEW_TYPE_OF_PROVIDER } from '../../../util/types';
import { Reviews } from '../../../components';

import css from './ClassDetail.module.css';

/**
 * Native marketplace reviews (real, from completed bookings) in the KidHive card. The mockup's
 * Yelp/Google scores and rating bars are intentionally absent: no external-ratings data exists
 * (flagged to the client). Hidden while there are no reviews; a fetch error shows a small note
 * instead (rendered by the body).
 *
 * KidHive reviews are ONE-WAY (parents review providers, not vice versa), so this public list shows
 * only reviews OF THE PROVIDER. The listing review query returns every public review on the
 * listing's transactions, which for LEGACY bookings can include a provider's review OF the parent
 * (type of-customer); those are filtered out here so a parent is never publicly reviewed.
 */
const ClassReviews = props => {
  const { reviews = [] } = props;
  const providerReviews = reviews.filter(r => r.attributes?.type === REVIEW_TYPE_OF_PROVIDER);

  if (providerReviews.length === 0) {
    return null;
  }

  return (
    <section className={css.card}>
      <h2 className={css.sectionTitle}>
        <FormattedMessage
          id="ClassDetailPage.reviewsTitle"
          values={{ count: providerReviews.length }}
        />
      </h2>
      <div className={css.reviewsList}>
        <Reviews reviews={providerReviews} />
      </div>
    </section>
  );
};

export default ClassReviews;
